angular
    .module('dealerware.web.data')
    .factory('DealerwareAdditionalDriverCollection', ['Collection', '$dealerwareInternationalizationDateFormats' , function (Collection, $dealerwareInternationalizationDateFormats) {
        'use strict';
        var collection = new Collection({
            baseEndpoint: '/locations/:location_id/reservations/:reservation_id/additional_drivers',
            model: 'DealerwareAdditionalDriverModel',
            customActions: {
                index: {
                    method: 'GET',
                    ignoreDefaultRootNodeResponse: true,
                    ignoreDefaultAssociationMapper: true
                }
            },
            responseTransforms: {
                index: function(_, data) {
                    data.forEach(function (driver) {
                        ['date_of_birth', 'drivers_license_expiration', ].forEach(function (dateKey) {
                            driver.data[dateKey] = $dealerwareInternationalizationDateFormats.parseDateToDisplayOnTheApplication(driver.data[dateKey], ['YYYY-MM-DD', 'MM-DD-YYYY']);
                        });
                    });
                }
            }
        });
        jQuery.extend(collection.prototype, {});
        return collection;
}]);